export default "__VITE_ASSET__BeO0BwDC__"